import { adminPageNames } from '../../shared/adminPageNames';

export const FETCH_INITIAL_DATA_FOR_MODAL = `${adminPageNames.COMPANY_CODES}/FETCH_INITIAL_DATA_FOR_MODAL`;
export const FETCH_INITIAL_DATA_FOR_MODAL_SUCCESS = `${adminPageNames.COMPANY_CODES}/FETCH_INITIAL_DATA_FOR_MODAL_SUCCESS`;
export const FETCH_INITIAL_DATA_FOR_MODAL_FAILURE = `${adminPageNames.COMPANY_CODES}/FETCH_INITIAL_DATA_FOR_MODAL_FAILURE`;

export const IMPORTING_COMPANY_CODE = 'IMPORTING_COMPANY_CODE';
export const IMPORTING_COMPANY_CODE_SUCCESS = 'IMPORTING_COMPANY_CODE_SUCCESS';
export const IMPORTING_COMPANY_CODE_FAILURE = 'IMPORTING_COMPANY_CODE_FAILURE';

export const REFRESH_OBLIGATIONS = 'REFRESH_OBLIGATIONS';
export const REFRESH_OBLIGATIONS_SUCCESS = 'REFRESH_OBLIGATIONS_SUCCESS';
export const REFRESH_OBLIGATIONS_FAILURE = 'REFRESH_OBLIGATIONS_FAILURE';

export const ASSOCIATED_LE_COUNTRY_CODE = 'US';
